<template>
  <div class="parent-box">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-container">

            <div class="text-right">
                    <p class="text-right text-danger point" style="cursor: pointer" @click="$emit('close')">Close</p>
            </div>

              <div class="modal-body">
              <div class="d-flex justify-content-center align-items-center">
                        <div class="text-center">
                <i class="fa fa-times font-weight-bold fa-4x text-danger"></i>
                <p class="text-danger font-weight-bold">Error!, {{modalstateError}}</p>
                </div>
        </div>
                <div>
      
      <div>
        <!-- form elements -->
        

        <!-- real footer item -->
       

        
       
      </div>
    
    </div>
              </div>

            
            </div>
          </div>
        </div>
      </transition>
  </div>
</template>

<script>

export default {
  name: "ModalError",
  props:['modalstateError'],
   components: {
   
  },
  computed: {},
  data() {
    return {
      form: {
        bvn: ""
      },
      formErrors: {},
      // activeIndex: 0,
      summary: {}
    };
  },

  methods: {
    gotoNextState() {
      // this.$emit("updateStatus");
    }
  },
  async mounted() {}
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/_reduced_variables.scss";

.modal-mask {
  margin-top: 10px;
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 450px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-footer{
    text-align: center;

}
.point{
    cursor: 'pointer';
}

.modal-header h1 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
  h1{
      font-size:40px;
      font-weight: 800;
  }
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.submit-button {
  display: block;
  color: white;
  width: 100%;
  text-align: center;
  float:right;
  padding: 15px 32px;
  margin-top: 20px;
  border: 0;
  background-color: $secondary-color;
  font-weight: bold;

  &:hover {
    background-color: darken($secondary-color, 10%);
  }
}
.heading {
  text-align: center;
  margin: auto;
  max-width: 550px;
}


.link {
  color: $primary-color;
  font-weight: bold;
}




.login-title {
  margin-bottom: 40px;
  font-weight: 900;
  font-size: 32px;
  // color: $primary-color;
}

.submit-gif{
   display: block;
   float:right;
  color: white;
  width: 100%;
  text-align: center;
  color:white;
  padding: 15px 32px;
  margin-top: 20px;
  border: 0;
  background-color: $secondary-color;

}



</style>



// WEBPACK FOOTER //
// src/components/pages/kitchen/Onboarding/modal-error.vue